import React, { Component } from 'react';
import actions from '../actions';
import entityActions from '../../entities/actions';
import roleActions from '../../roles/actions';
import sharedActions from '../../shared/actions';
import { connect } from 'react-redux';
import UsersForm from './../components/UsersForm';
import Validators from './../../shared/utils/Validators';
import { I18n } from 'react-redux-i18n';
import _ from '../../shared/utils/ObjectUtils';

class UsersFormContainer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            viewMode: !_.isNilOrEmpty(props.userId),
            editMode: false,
            createMode: _.isNilOrEmpty(props.userId),
            alert: {
                show: false
            },
            userFormData: {
                firstName: {
                    value: undefined,
                    error: undefined,
                    required: true
                },
                lastName: {
                    value: undefined,
                    error: undefined,
                    required: true
                },
                email: {
                    value: undefined,
                    error: undefined,
                    required: true
                },
                status: {
                    value: undefined,
                    required: true
                },
                role: {
                    value: undefined,
                    error: undefined,
                    data: [],
                    required: true
                },
                entity: {
                    value: undefined,
                    error: undefined,
                    data: [],
                    required: true
                },
                language: {
                    value: undefined,
                    error: undefined,
                    data: [],
                    required: true
                },
                timezone: {
                    value: undefined,
                    error: undefined,
                    data: [],
                    required: true
                }
            }
        }
    }

    componentDidMount() {
        const {
            userId,
            getEntityList,
            getUserData
        } = this.props;

        if (userId) {
            getUserData(userId);
        }
        getEntityList();
        // Get Timezone and Languages ?
    };

    componentWillUnmount() {
        this.props.updateCustomTitle();
        this.props.updateCustomBreadcrumbs();
    }

    componentWillReceiveProps(nextProps) {
        //Handle Error, Edit and Create
        if (this.props.loadingDeleteRequest && !nextProps.loadingDeleteRequest) {
            if (nextProps.userWasDeleted) {
                this.handleUserDeleteSuccess()
            } else {
                this.handleUserDeleteError(nextProps.error)
            }
        } else if (this.props.loadingCreateRequest && !nextProps.loadingCreateRequest) {
            if (nextProps.userWasCreated) {
                this.handleUserCreateSuccess()
            } else {
                this.handleUserCreateError(nextProps.error)
            }
        } else if (this.props.loadingEditRequest && !nextProps.loadingEditRequest) {
            if (nextProps.userWasEdited) {
                this.handleUserEditSuccess()
            } else {
                this.handleUserEditError(nextProps.error)
            }
        } else if (this.props.loadingUser && !nextProps.loadingUser) {
            this.handleUserLoadingCompleted(nextProps.userData);
        }
    };

    handleUserLoadingCompleted = userData => {

        //Update Page Title and Breadcrumbs
        const {
            updateCustomTitle,
            updateCustomBreadcrumbs
        } = this.props;

        const userFullName = userData.firstName + " " + userData.lastName;

        updateCustomTitle(userFullName);
        updateCustomBreadcrumbs([{
            link: "/users",
            name: I18n.t('routes.users')
        }, {
            link: "/users/" + userData.id,
            name: userFullName
        }]);

        if (userData.entity) {
            this.props.getRoleList({
                userEntityId: userData.entity
            });
        }
        this.setState({
            userFormData: {
                ...this.state.userFormData,
                ...Object.entries(userData).reduce(
                    (acc, keyValuePair) => ({
                        ...acc,
                        [keyValuePair[0]]: {
                            ...acc[keyValuePair[0]],
                            ...this.state.userFormData[keyValuePair[0]],
                            value: keyValuePair[1]
                        }
                    }), {})
            }
        })
    }

    handleFieldChange = (id, value) => {
        const {
            getRoleList
        } = this.props;

        if (id === "entity") {
            getRoleList({
                userEntityId: value
            });
        }
        this.setState({
            userFormData: {
                ...this.state.userFormData,
                [id]: {
                    ...this.state.userFormData[id],
                    value: value
                }
            }
        }, () => {
            if (_.has(this.state.userFormData[id], 'required')) {
                this.validateField(id);
            }
        })
    };

    validateField = (key) => {
        let { userFormData } = this.state;
        let error = null;
        switch (key) {
            case "email":
                error = !Validators.email(userFormData[key].value) ? I18n.t('users.errors.invalidEmail') : undefined;
                break;
            case "firstName":
                error = !_.isNilOrEmpty(userFormData[key].value) ? (!Validators.hasSpecialCharacters(userFormData[key].value) ? I18n.t('users.errors.specialCharacters') : undefined) : I18n.t('forms.errors.emptyRequiredField');
                break;
            case "lastName":
                error = !_.isNilOrEmpty(userFormData[key].value) ? (!Validators.hasSpecialCharacters(userFormData[key].value) ? I18n.t('users.errors.specialCharacters') : undefined) : I18n.t('forms.errors.emptyRequiredField');
                break;
            default:
                break;
        }
        if (
            !_.isNilOrEmpty(userFormData[key].error) &&
            _.isNilOrEmpty(error) &&
            userFormData[key].required &&
            !_.isNilOrEmpty(userFormData[key].value)
        ) {
            error = undefined;
        } else if (
            _.isNilOrEmpty(error) &&
            userFormData[key].required &&
            _.isNilOrEmpty(userFormData[key].value)
        ) {
            error = I18n.t('forms.errors.emptyRequiredField')
        }
        if (error !== userFormData[key].error) {
            userFormData[key].error = error;
            this.setState({
                userFormData,
            });
        }
    };

    handleOnFieldBlur = (key) => {
        this.validateField(key)
    };

    handleSubmitClick = () => {
        let { editMode, userFormData } = this.state
        const { userId, editUser, createUser } = this.props
        let formHasErrors = false;

        _.forOwn(userFormData, field => {
            if((field.required && _.isNilOrEmpty(field.value))) {
                field.error = I18n.t('forms.errors.emptyRequiredField');
                formHasErrors = true;
            } else if(!_.isNilOrEmpty(field.error)) {
                formHasErrors = true;
            } else {
                field.error = undefined;
            }
        });

        if(!formHasErrors) {
            const formDataToBeSubmitted = Object.entries(userFormData).reduce((acc, keyValuePair) => {
                return {
                    ...acc,
                    [keyValuePair[0]]: keyValuePair[1].value,
                }
            }, { })
            const userFullName = formDataToBeSubmitted.firstName + " " + formDataToBeSubmitted.lastName;
            if (editMode) {
                this.setState({
                    alert: {
                        show: true,
                        type: "warning",
                        title: I18n.t('users.alerts.edit.title'),
                        html: I18n.t('users.alerts.edit.text', {user: userFullName}),
                        confirmButtonText: I18n.t('forms.submit'),
                        cancelButtonText: I18n.t('forms.cancel'),
                        onCancel: this.hideAlert,
                        onConfirm: () => {
                            editUser(userId, formDataToBeSubmitted, false)
                        }
                    }
                })
            } else {
                this.setState({
                    alert: {
                        show: true,
                        type: "warning",
                        title: I18n.t('users.alerts.create.title'),
                        html: I18n.t('users.alerts.create.text', {user: userFullName}),
                        confirmButtonText: I18n.t('forms.submit'),
                        cancelButtonText: I18n.t('forms.cancel'),
                        onCancel: this.hideAlert,
                        onConfirm: () => {
                            createUser(formDataToBeSubmitted)
                        }
                    }
                })
            }
        } else {
            this.setState({
                userFormData,
            });
        }
    };

    handleEditClick = () => {
        const { editMode } = this.state;
        const { userData } = this.props;

        if (editMode) {
            this.setState({
                ...this.state,
                editMode: false,
                viewMode: true,
                userFormData:
                    Object.entries(this.state.userFormData).reduce((acc, keyValuePair) => {
                        return {
                            ...acc,
                            [keyValuePair[0]]: {
                                ...this.state.userFormData[keyValuePair[0]],
                                value: userData[keyValuePair[0]] ? userData[keyValuePair[0]] : undefined,
                                error: undefined,
                            }
                        }
                    }, {})
            })
        } else {
            this.setState({
                viewMode: false,
                editMode: true
            })
        }
    }

    hideAlert = () => {
        this.setState({
            alert: {
                show: false
            }
        })
    }

    handleBackClick = () => {
        this.props.resetUserForm();
        this.hideAlert();
        this.props.history.push({
            pathname: '/users',
            state: { 
                searchFieldsData : this.props.location.state?.searchFieldsData, 
                universalSearchField :  this.props.location.state?.universalSearchField
            }
        });
    }

    handleDeleteClick = () => {
        const { userId, deleteUser } = this.props;
        const {
            userFormData: {
                firstName: {
                    value: firstName
                },
                lastName: {
                    value: lastName
                }
            }
        } = this.state;

        this.setState({
            alert: {
                show: true,
                type: "warning",
                title: I18n.t('users.alerts.delete.title'),
                html: I18n.t('users.alerts.delete.text', { user: firstName + " " + lastName }),
                confirmButtonText: I18n.t('forms.delete'),
                cancelButtonText: I18n.t('forms.cancel'),
                onCancel: this.hideAlert,
                onConfirm: () => {
                    deleteUser(userId)
                }
            }
        })
    }

    handleUserDeleteSuccess = () => {
        const {
            userFormData: {
                firstName: {
                    value: firstName
                },
                lastName: {
                    value: lastName
                }
            }
        } = this.state;

        this.setState({
            alert: {
                show: true,
                type: 'success',
                title: I18n.t('users.alerts.delete.success.title'),
                html: I18n.t('users.alerts.delete.success.text', { user: firstName + " " + lastName }),
                confirmButtonText: I18n.t('forms.ok'),
                onCancel: this.handleBackClick,
                onConfirm: this.handleBackClick
            }
        })
    }

    handleUserDeleteError = error => {
        this.setState({
            alert: {
                show: true,
                type: 'error',
                title: I18n.t('users.alerts.delete.error.title'),
                html: I18n.t('users.alerts.delete.error.text'),
                confirmButtonText: I18n.t('forms.ok'),
                onConfirm: this.hideAlert
            }
        })
    }

    handleUserCreateSuccess = () => {
        const {
            userFormData: {
                firstName: {
                    value: firstName
                },
                lastName: {
                    value: lastName
                }
            }
        } = this.state;

        this.setState({
            alert: {
                show: true,
                type: 'success',
                title: I18n.t('users.alerts.create.success.title'),
                html: I18n.t('users.alerts.create.success.text', { user: firstName + " " + lastName }),
                confirmButtonText: I18n.t('forms.ok'),
                onCancel: this.handleBackClick,
                onConfirm: this.handleBackClick
            }
        })
    }

    handleUserCreateError = error => {
        this.setState({
            alert: {
                show: true,
                type: 'error',
                title: I18n.t('users.alerts.create.error.title'),
                html: I18n.t('users.alerts.create.error.text'),
                confirmButtonText: I18n.t('forms.ok'),
                onConfirm: this.hideAlert
            }
        })
    }

    handleUserEditSuccess = () => {
        const {
            userFormData: {
                firstName: {
                    value: firstName
                },
                lastName: {
                    value: lastName
                }
            }
        } = this.state;

        this.setState({
            alert: {
                show: true,
                type: 'success',
                title: I18n.t('users.alerts.edit.success.title'),
                html: I18n.t('users.alerts.edit.success.text', { user: firstName + " " + lastName }),
                confirmButtonText: I18n.t('forms.ok'),
                onCancel: this.handleBackClick,
                onConfirm: this.handleBackClick
            }
        })
    }

    handleUserEditError = error => {
        this.setState({
            alert: {
                show: true,
                type: 'error',
                title: I18n.t('users.alerts.edit.error.title'),
                html: I18n.t('users.alerts.edit.error.text'),
                confirmButtonText: I18n.t('forms.ok'),
                onConfirm: this.hideAlert
            }
        })
    }

    render() {
        const {
            createMode,
            editMode,
            viewMode,
            userFormData,
            alert
        } = this.state;

        const {
            entityList,
            roleList,
            loadingDeleteRequest,
            loadingCreateRequest,
            loadingEditRequest
        } = this.props;

        return <UsersForm
            editMode={editMode}
            createMode={createMode}
            viewMode={viewMode}
            alert={{
                ...alert,
                loading: loadingDeleteRequest || loadingCreateRequest || loadingEditRequest
            }}

            userFormData={userFormData}
            entityList={entityList}
            roleList={roleList}

            handleFieldChange={this.handleFieldChange}
            handleOnFieldBlur={this.handleOnFieldBlur}
            handleSubmitClick={this.handleSubmitClick}

            handleEditClick={this.handleEditClick}
            handleDeleteClick={this.handleDeleteClick}
            handleBackClick={this.handleBackClick}
        />
    }
}

const mapStateToProps = ({
    usersReducer,
    entitiesReducer,
    rolesReducer
}) => {
    return {
        entityList: entitiesReducer.entityList,
        roleList: rolesReducer.roleList,

        userData: usersReducer.userData,
        loadingUser: usersReducer.loading,
        error: usersReducer.error,

        loadingDeleteRequest: usersReducer.loadingDeleteRequest,
        userWasDeleted: usersReducer.userWasDeleted,

        loadingCreateRequest: usersReducer.loadingCreateRequest,
        userWasCreated: usersReducer.userWasCreated,

        loadingEditRequest: usersReducer.loadingEditRequest,
        userWasEdited: usersReducer.userWasEdited
    };
};

const mapDispatchToProps = {
    getUserData: actions.getUserData,
    createUser: actions.createUser,
    editUser: actions.editUser,
    deleteUser: actions.deleteUser,
    resetUserForm: actions.resetUserForm,
    getEntityList: entityActions.getEntityList,
    getRoleList: roleActions.getRoleList,

    updateCustomTitle: sharedActions.updateCustomTitle,
    updateCustomBreadcrumbs: sharedActions.updateCustomBreadcrumbs
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(UsersFormContainer);
